import type { AttributionProperties } from '../types/analytics'

export const GOOGLE_PLAY_PACKAGE = 'cn.ilnet.povli'
const DEFAULT_GOOGLE_PLAY_URL = `https://play.google.com/store/apps/details?id=${GOOGLE_PLAY_PACKAGE}`

function configuredGooglePlayUrl() {
  const configured = import.meta.env.VITE_GOOGLE_PLAY_URL?.trim()
  if (!configured) return DEFAULT_GOOGLE_PLAY_URL
  try {
    const url = new URL(configured)
    if (url.protocol !== 'https:' || url.hostname !== 'play.google.com' || url.searchParams.get('id') !== GOOGLE_PLAY_PACKAGE) {
      return DEFAULT_GOOGLE_PLAY_URL
    }
    return url.toString()
  } catch {
    return DEFAULT_GOOGLE_PLAY_URL
  }
}

export const GOOGLE_PLAY_URL = configuredGooglePlayUrl()

export interface AppHandoffLinks {
  handoffId: string
  sourceLanding: string
  targetLanding: string | null
  googlePlayUrl: string
  appUrl: string | null
}

interface CreateAppHandoffOptions {
  sourceLanding: string
  targetLanding?: string
  attribution: AttributionProperties
  handoffId?: string
}

function add(params: URLSearchParams, key: string, value: string | null | undefined) {
  const trimmed = value?.trim()
  if (trimmed) params.set(key, trimmed.slice(0, 500))
}

export function createAppHandoffLinks(options: CreateAppHandoffOptions): AppHandoffLinks {
  const handoffId = options.handoffId ?? crypto.randomUUID()
  const referrer = new URLSearchParams()
  add(referrer, 'handoff_id', handoffId)
  add(referrer, 'source_landing', options.sourceLanding)
  add(referrer, 'target_landing', options.targetLanding)
  add(referrer, 'campaign_id', options.attribution.campaign_id)
  add(referrer, 'adset_id', options.attribution.adset_id)
  add(referrer, 'ad_id', options.attribution.ad_id)
  add(referrer, 'creative', options.attribution.creative)
  add(referrer, 'utm_source', options.attribution.utm_source)
  add(referrer, 'utm_medium', options.attribution.utm_medium)
  add(referrer, 'utm_campaign', options.attribution.utm_campaign)
  add(referrer, 'utm_content', options.attribution.utm_content)
  add(referrer, 'utm_term', options.attribution.utm_term)
  add(referrer, 'fbclid', options.attribution.fbclid)

  const googlePlay = new URL(GOOGLE_PLAY_URL)
  googlePlay.searchParams.set('referrer', referrer.toString())

  const appParams = new URLSearchParams(referrer)
  appParams.delete('target_landing')
  const appUrl = options.targetLanding
    ? `povli://story/${encodeURIComponent(options.targetLanding)}?${appParams.toString()}`
    : null

  return {
    handoffId,
    sourceLanding: options.sourceLanding,
    targetLanding: options.targetLanding ?? null,
    googlePlayUrl: googlePlay.toString(),
    appUrl,
  }
}
